<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="end">
        <ion-button @click="cerrar">
          <i class="icon ion-ios-close-circle-outline"></i>
        </ion-button>
      </ion-buttons>
      <ion-title>Seleccionar equipo ({{equipos.length}})</ion-title>
    </ion-toolbar>
    <ion-item lines="none" color="primary">
      <ion-note slot="start" color="">
        <i class="icon ion-ios-contact"></i>
      </ion-note>
      <ion-label>
        <h2>{{cliente.alias || cliente.nombre}}</h2>
        <p>{{cliente.email}} {{cliente.telefono}} {{cliente.telefonos}}</p>
      </ion-label>
    </ion-item>
    <ion-searchbar placeholder="Buscar por SN, tipo, marca o área" v-on:ionChange="filtrar($event.detail.value)" debounce="250"></ion-searchbar>
  </ion-header>
  <ion-content>
    <ion-list v-if="esMovil">
      <ion-item v-for="e in equiposFiltrados" :key="e._id" @click="seleccionarEquipo(e)">
        <ion-label>
          <h2>{{e.tipo}}</h2>
          <p>{{e.marca}} {{e.modelo}}</p>
          <p>Numero de serie: {{e.sn}}</p>
          <p v-if="((e.area||'')+(e.subarea||'')).length>0">{{e.area}} <span v-if="e.area!=e.subarea">{{e.subarea}}</span></p>
        </ion-label>
      </ion-item>
    </ion-list>
    <div v-else>
      <table class="tablaEquipos">
        <thead>
          <tr>
            <th>Marca</th>
            <th>Modelo</th>
            <th>SN</th>
            <th class="ion-text-right">...</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="e in equiposFiltrados" :key="e._id">
            <td>{{e.marca}}</td>
            <td>{{e.modelo}}</td>
            <td>{{e.sn || e.alias}}</td>
            <td class="ion-text-right">
              <ion-button size="small" fill="solid" color="medium" @click="seleccionarEquipo(e)">
                Seleccionar
              </ion-button>
              <ion-button size="small" fill="outline" color="medium" @click="$router.push('/catalogos/equipos/'+e._id+'/modo/historial')">
                Historial
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ion-content>
</ion-app>
</template>
<style>
.tablaEquipos {
  width: 100%;
}

.tablaEquipos tr:nth-child(even) {
  background-color: #f8f8f8;
}

.tablaEquipos th,
.tablaEquipos td {
  padding: 8px;
  text-align: left;
}
</style>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'ModalSeleccionarEquipo',
  props: ['equipos', 'cliente'],
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      equiposFiltrados: [],
      esMovil: Api.esMovil()
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    cerrar() {
      console.log("$emit cerrarModal")
      Api.$emit('ModalSeleccionarEquipoCerrar')
    },
    seleccionarEquipo(e) {
      Api.$emit('seleccionarEquipo', e)
    },
    filtrar(str) {
      str = (str || '').toUpperCase()
      this.equiposFiltrados = this.equipos
        .filter(e => {
          let params = ['sn', 'tipo', 'marca', 'modelo', 'area', 'subarea']
          let strC = ''
          for (let p of params)
            if (e[p] && e[p] != '')
              strC += e[p]
          strC = strC.toUpperCase()
          return strC.indexOf(str) >= 0
        })
      try {
        this.equiposFiltrados = this.equiposFiltrados
          .sort((a, b) => a.tipo > b.tipo ? 1 : -1)
      } catch (e) {}
    }
  },
  async mounted() {
    console.log("ModalSeleccionarEquipo", this.equipos.length, this.cliente.nombre)
    this.filtrar('')
  }
}
</script>
